export const exhortationNotesEndpoints = {
  create: "/api/exhortation-notes",
  read: (id) => `/api/exhortation-notes/${id}`,
  update: (id) => `/api/exhortation-notes/${id}/update`,
  delete: (id) => `/api/exhortation-notes/${id}`,
  show: (id) => `/api/exhortation-notes/${id}`,
  showByRid: (rid) => `${rid}/rid`,
};
